import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';

// import './lib/flexible';
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
Vue.use(ViewUI);

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)
Vue.use(function(Vue){
	Vue.mixin({
		data(){
			return {
				logIsShowMarkder:false
			}
		},
		created() {
			if(location.href.includes('farmId')){
				this.logIsShowMarkder = false
			}else{
				this.logIsShowMarkder = true
			}
			Vue.prototype.logIsShowMarkder = this.logIsShowMarkder
		}
	})
})

import "./lib/log-utils.css";

import "./components/camera/style/videorecorder.css";
require('./components/camera/tools/creatSvgIcon.js')

Vue.config.productionTip = false;

new Vue({
  router,
  store,

  render: (h) => h(App),
}).$mount('#app');
